import React from 'react';
import { classNames } from 'src/utils/classNames';
import styles from './index.module.scss';

interface Props {
  children?: any;
  type: 'primary' | 'accent';
  size?: 'small' | 'large' | 'medium';
  onClick?: () => any;
}
const ImageButton: React.FC<Props> = ({ children, type, onClick, size }) => {
  return (
    <button
      className={classNames([
        styles.container,
        styles[type],
        styles[size || 'small']
      ])}
      onClick={onClick}
    >
      {React.Children.map(children, child => child)}
    </button>
  );
};

export default ImageButton;
